import { ArticleParagraph2, IconFunctionalWarningSign24 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './styles.css';

interface IErrorMessageBannerProps {
  title: string;
}

export const ErrorMessageBanner: React.FC<IErrorMessageBannerProps> = ({ title }) => {
  return (
    <div className={styles['container']}>
      <IconFunctionalWarningSign24 color="warning_100" />
      <ArticleParagraph2>{title}</ArticleParagraph2>
    </div>
  );
};
